<dojo-sidenav
  [items]="state.sidenavItems"
  logoCompact="assets/images/logo/logo-compact.svg"
  logoCompactDark="assets/images/logo/logo-compact-dark.svg"
  logoFull="assets/images/logo/logo-color-horizontal.svg"
  logoFullDark="assets/images/logo/logo-color-horizontal-dark.svg"
  logoAlt="ExamDojo"
  [settingsRoute]="settingsRoute"
  [hasMobileTopPanel]="state.hasOngoingActivity"
  [newMobileMenu]="state.newMobileMenu"
  [isMoreMenuOpen]="state.isMoreMenuOpen"
  (moreClicked)="onMoreClicked()"
  (menuItemClicked)="onMenuItemClicked()"
>
  <ng-template #mobileTopPanel>
    <dojo-resume-activity-button />
  </ng-template>

  <ng-template #sidenavFooter>
    <wide-layout>
      <dojo-resume-activity-button />
    </wide-layout>
  </ng-template>

  <router-outlet />
</dojo-sidenav>
